import PropTypes from 'prop-types';
import { Alert, AlertTitle, Button, Stack } from '@mui/material';
import useAuth from '../../hooks/useAuth';
import { isModuleAllowed, isPermissionAllowed } from '../accessControl';

export default function PermissionGate({
  moduleName,
  permissionCode,
  children,
  fallback,
  requestAccessAction,
  title = 'Permission required',
  description = 'Your current admin session cannot perform this action.',
}) {
  const { permissionMap, currentAdmin } = useAuth();
  const isSuperAdmin = Boolean(currentAdmin?.is_super_admin);
  const allowedByModule = isModuleAllowed(permissionMap, moduleName, isSuperAdmin);
  const allowedByPermission = isPermissionAllowed(permissionMap, permissionCode, isSuperAdmin);

  if (allowedByModule && allowedByPermission) {
    return <>{children}</>;
  }

  if (fallback) {
    return fallback;
  }

  return (
    <Alert severity="warning" variant="outlined">
      <AlertTitle>{title}</AlertTitle>
      <Stack spacing={1}>
        <span>{description}</span>
        {requestAccessAction && (
          <Button size="small" variant="outlined" onClick={requestAccessAction}>
            Request Access
          </Button>
        )}
      </Stack>
    </Alert>
  );
}

PermissionGate.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.string,
  fallback: PropTypes.node,
  moduleName: PropTypes.string,
  permissionCode: PropTypes.string,
  requestAccessAction: PropTypes.func,
  title: PropTypes.string,
};

PermissionGate.defaultProps = {
  description: 'Your current admin session cannot perform this action.',
  fallback: null,
  moduleName: null,
  permissionCode: null,
  requestAccessAction: null,
  title: 'Permission required',
};
